import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Backdrop from '@material-ui/core/Backdrop';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import NoteIcon from '@material-ui/icons/Note';
import PeopleIcon from '@material-ui/icons/People';

import logo from '../../assets/logo/Logo.png';
import { shortFullName } from '../../utils';
import CanvaKoin from '../KonectaWorld/Map/models/CanvaKoin';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1, 0),
    background: theme.palette.background.primary,
  },
  title: {
    flexGrow: 1,
    fontFamily: 'Raleway',
  },
  img: {
    maxWidth: '82px',
    maxHeight: '74px',
    marginLeft: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    background: theme.palette.background.secondary,
    padding: theme.spacing(1, 5),
    borderRadius: '8px',
    margin: theme.spacing(1, 1, 1, 2),
  },
  icon: {
    marginLeft: theme.spacing(6),
  },
  iconUser: {
    marginLeft: theme.spacing(2),
  },
  iconMenu: {
    cursor: 'pointer',
  },
  notification: {
    color: theme.palette.common.white,
  },
  itemMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.black,
  },
  font: {
    fontFamily: 'Raleway',
  },
  fontKoins: {
    margin: theme.spacing(2, 0),
    fontSize: 20,
    fontFamily: 'Raleway',
    fontWeight: 500,
    textAlign: 'center',
    color: theme.palette.text.default,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.common.black,
  },
  containerKoins: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
}));

const StyledMenu = withStyles({
  paper: {
    width: 190,
    borderRadius: 0,
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.pink,
      },
    },
  },
}))(MenuItem);

export default function NavBar() {
  //  recuperar la carpeta de amplify
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { infoUser } = useSelector((store) => store.login);
  const shortName = shortFullName();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Box className={classes.title}>
            <img className={classes.img} alt="logo" src={logo} />
          </Box>
          <Box className={classes.containerKoins}>
            <Typography className={classes.fontKoins}>{infoUser.totalKoins}</Typography>
            <CanvaKoin widthValue={50} heightValue={60} />
          </Box>
          <Box className={classes.container} onClick={handleClick}>
            <Typography className={classes.font}>{shortName}</Typography>
            <AccountCircleIcon className={classes.iconUser} />
            <KeyboardArrowDownIcon className={classes.iconMenu} />
          </Box>
          <Backdrop
            className={classes.backdrop}
            open={open}
            onClick={handleClose}
          >
            <StyledMenu
              onClick={handleClose}
              id="customized-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
            >
              <Link to="/notes" className={classes.link}>
                <StyledMenuItem>
                  <ListItemText primary="Mis notas" />
                  <ListItemIcon>
                    <NoteIcon className={classes.icon} />
                  </ListItemIcon>
                </StyledMenuItem>
              </Link>
              <Divider />
              <Link to="/home" className={classes.link}>
                <StyledMenuItem>
                  <ListItemText primary="Cursos" />
                  <ListItemIcon>
                    <LocalLibraryIcon className={classes.icon} />
                  </ListItemIcon>
                </StyledMenuItem>
              </Link>

              <Divider />
              <Link to="/mentor" className={classes.link}>
                <StyledMenuItem>
                  <ListItemText primary="Contactar mentor" />
                  <ListItemIcon>
                    <PeopleIcon className={classes.icon} />
                  </ListItemIcon>
                </StyledMenuItem>
              </Link>
              <Divider />
              <Link to="/" className={classes.link}>
                <StyledMenuItem>
                  <ListItemText
                    primary="Cerrar sesión"
                  />
                  <ListItemIcon>
                    <ExitToAppIcon className={classes.icon} />
                  </ListItemIcon>
                </StyledMenuItem>

              </Link>

            </StyledMenu>
          </Backdrop>
          {/*  <IconButton>
            <NotificationsActiveIcon className={classes.notification} />
          </IconButton> */}
        </Toolbar>
      </AppBar>
    </div>
  );
}
